import { useRef, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

// Records mic audio and transcribes it via /ai/transcribe (Whisper). Calls onText(transcript).
export function useDictation(onText) {
  const [recording, setRecording] = useState(false);
  const [transcribing, setTranscribing] = useState(false);
  const mrRef = useRef(null);
  const chunksRef = useRef([]);

  const start = async () => {
    if (!navigator.mediaDevices?.getUserMedia) {
      toast.error("Microphone not supported in this browser");
      return;
    }
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream);
      chunksRef.current = [];
      mr.ondataavailable = (e) => { if (e.data.size > 0) chunksRef.current.push(e.data); };
      mr.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        const blob = new Blob(chunksRef.current, { type: mr.mimeType || "audio/webm" });
        if (!blob.size) return;
        setTranscribing(true);
        try {
          const fd = new FormData();
          fd.append("audio", blob, "speech.webm");
          const { data } = await api.post("/ai/transcribe", fd, { headers: { "Content-Type": "multipart/form-data" } });
          if (data.text) { onText(data.text); toast.success("Added your dictation"); }
          else toast.error("Didn't catch that — try again");
        } catch { toast.error("Could not transcribe audio"); }
        finally { setTranscribing(false); }
      };
      mr.start();
      mrRef.current = mr;
      setRecording(true);
    } catch { toast.error("Microphone permission denied"); }
  };

  const stop = () => { mrRef.current?.stop(); setRecording(false); };
  const toggle = () => (recording ? stop() : start());

  return { recording, transcribing, toggle };
}
